<template>
  <div class="pt-collapse" :class="showVisible ? 'pt-collapse-active':''">
    <div class="pt-collapse-header" @click="toggleShow">
      <div class='round_div'></div>
      {{title}}
      <a-icon class="ant-collapse-arrow" v-if='showVisible' type="caret-up"/>
      <a-icon class="ant-collapse-arrow" v-else type="caret-down"/>
    </div>
    <div class="pt-collapse-content" v-show="showVisible">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ptCollapseIndustrial',
  props:{
    title:{
      type:String,
      default:'',
    },
    showOption:{ //初始显示状态,默认不展开
      type:Boolean,
      default: false,
    }
  },
  mounted(){
    this.init();
  },
  data(){
    return{
      showVisible:false,
    }
  },
  methods:{
    init(){
      if(this.showOption){
        this.showVisible = true;
      }
    },
    toggleShow(){
      this.showVisible = !this.showVisible;
    }
  }
}
</script>

<style scoped lang="less">
.pt-collapse{
  user-select: none;
  box-sizing: border-box;
  background-color: #ffffff;
  width: 100%;
  margin-bottom: 10px;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  border-radius: 4px;
  border: 0;
  overflow: hidden;
}
.pt-collapse-header{
  box-sizing: border-box;
  /*border-radius: 4px;*/
  background: #F4F5F8;
  border: 0;
  overflow: hidden;
  font-size: 14px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 600;
  position: relative;
  padding: 12px 0 12px 7%;
  line-height: 22px;
  cursor: pointer;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  display: flex;
  align-items: center;
}

.round_div{
  width: 12px;
  height: 12px;
  background-color: #FABE00;
  border-radius: 6px;
  margin-right: 10px;
}

.ant-collapse-arrow{
  margin-left: 30px;
  font-style: normal;
  text-align: center;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #D4D4D4;
  display: inline-block;
  font-size: 12px;

}
.pt-collapse-content{
  box-sizing: border-box;
  background: #FFFFFF;
  border-left: 0.5px solid #E9E9E9;
  border-right: 0.5px solid #E9E9E9;
  border-bottom: 0.5px solid #E9E9E9;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.65);
  padding: 4px 16px 16px 16px;
}
.pt-collapse-active{
  .ant-collapse-arrow{
    /*transition: transform 0.24s;*/
    svg{
      transform: rotate(90deg);
      transition: transform 0.24s;
    }
  }
  .pt-collapse-content{
    transition: height 0.2s ease-out;
  }
}
</style>